export default "__VITE_ASSET__Mq7Lnl$m__"